import React from "react";
import { Box, Typography, Button, Container, Grid } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import InsightsIcon from "@mui/icons-material/Insights";
import ReportIcon from "@mui/icons-material/Report";

const SplashSection = ({ onUploadClick }) => {
  const features = [
    {
      icon: <InsightsIcon sx={{ fontSize: 60, mb: 2, color: "#FFC107" }} />,
      title: "Interactive Charts",
      description: "Visualize your average balances and trends effortlessly.",
    },
    {
      icon: <ReportIcon sx={{ fontSize: 60, mb: 2, color: "#FFC107" }} />,
      title: "Custom Reports",
      description: "Generate detailed reports tailored to your financial data.",
    },
    {
      icon: <UploadIcon sx={{ fontSize: 60, mb: 2, color: "#FFC107" }} />,
      title: "Easy Data Upload",
      description: "Drag and drop your financial files to start analyzing.",
    },
  ];

  return (
    <Box
      id="splash-section"
      sx={{
        backgroundColor: "#003366",
        color: "#fff",
        py: { xs: 4, md: 8 },
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="h3" sx={{ fontWeight: "bold", mb: 2 }}>
          Welcome to FinancePro
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            mb: 4,
            color: "rgba(255, 255, 255, 0.8)",
            letterSpacing: "0.5px",
          }}
        >
          Simplify your financial analysis with powerful tools to track
          balances, visualize trends, and manage transactions.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          startIcon={<UploadIcon />}
          onClick={onUploadClick}
          aria-label="Upload your financial data"
          sx={{
            px: 4,
            py: 1.5,
            fontSize: "1rem",
            fontWeight: "bold",
          }}
        >
          Upload Your Data
        </Button>
        <Grid container spacing={4} sx={{ mt: 6 }}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              {feature.icon}
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                {feature.title}
              </Typography>
              <Typography variant="body2">{feature.description}</Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default SplashSection;

